"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tenantRegistry = void 0;
exports.tenantRegistry = {
    tenants: {
        '4f54c6aa-82a9-475d-bf0e-dc02ded89225': {
            platformDataCenter: 'rs',
        },
        '4dd61a16-9691-4277-9027-8cd05a647844': {
            platformDataCenter: 'rs2',
        },
    },
};
//# sourceMappingURL=TenantRegistry.js.map